export const API_DATE_FORMAT = 'YYYY-MM-DD';
export const JAPANESE_SHORT_DATE_FORMAT = "'YY年M月";
export const JAPANESE_YEAR_FORMAT = 'YYYY年';
export const ENGLISH_SHORT_DATE_FORMAT = "MMM 'YY";
export const ENGLISH_QUARTER_DATE_FORMAT = "[Q]Q 'YY";
export const ENGLISH_DAY_DATE_FORMAT = "MMM DD, 'YY";
export const ENGLISH_YEAR_FORMAT = 'YYYY';
export const ENGLISH_DATE_TIME_TIMEZONE_FORMAT = 'YYYY-MM-DD HH:mm z';
